import { brand } from './brand';

/**
 * The instance's mark.
 *
 * One component rather than six copies of an `<img>`, because the interesting
 * case is the one an `<img>` cannot express: an operator who supplied no logo.
 * That is a legitimate way to run this — not a degraded one — so it falls back to
 * the name set as a wordmark instead of a broken-image icon, and every header
 * gets that behaviour by construction rather than by remembering.
 */
export function Mark({ className = 'mx-logo' }: { className?: string }) {
  const b = brand();
  if (b.logo) {
    return <img className={className} src={b.logo} alt={b.name} />;
  }
  return <span className="mx-wordmark">{b.name}</span>;
}
